// extracted by mini-css-extract-plugin
export var standaloneTable = "_g4-0";
export var standaloneTableWithBodyFill = "_g4-1";
export var withExtraHeader = "_g4-2";